import { useHttpClient } from '@wix/fe-essentials/react';
import { useQuery } from '@wix/fe-essentials/react-query/react';
import { fetchChannelIds } from '../api/tpa-apis/wix-video/fetch-channel-ids';
import { fetchChannelVideos } from '../api/tpa-apis/wix-video/fetch-channel-videos';
import { QueryId } from './types';
export const useWixVideoDataQuery = () => {
  const httpClient = useHttpClient();
  return useQuery([QueryId.WixVideoData], () => {
    return fetchWixVideoData(httpClient);
  }, {
    enabled: false,
    refetchOnWindowFocus: false,
    retry: false
  });
};
const fetchWixVideoData = async httpClient => {
  const wixVideoDataMap = new Map();
  const channelIds = await fetchChannelIds(httpClient);
  const fetchItemsPromises = channelIds.map(async channelId => {
    const items = await fetchChannelVideos(httpClient, channelId);
    wixVideoDataMap.set(channelId, items);
  });
  await Promise.all(fetchItemsPromises);
  return wixVideoDataMap;
};
//# sourceMappingURL=use-wix-video-data-query.js.map